import { CART_TYPES } from '@/lib/models/cart/cartTypes'

const findCartByParam = (param, value) =>
  Object.values(CART_TYPES).find(
    ({ [param]: paramValue }) => paramValue === value
  )

export default findCartByParam
